export const ActionType={REANIMATED_WORKLET:1,NATIVE_ANIMATED_EVENT:2,JS_FUNCTION_OLD_API:3,JS_FUNCTION_NEW_API:4};